/* tslint:disable */
/* eslint-disable */
/**
 * Ofca
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, BaseAPI, operationServerMap } from './base';
/**
 *
 * @export
 * @enum {string}
 */
export var AdminApproved = {
    None: 'None',
    Allow: 'Allow',
    Disallow: 'Disallow',
    Continue: 'Continue'
};
/**
 *
 * @export
 * @enum {string}
 */
export var AllowedAction = {
    SetFullOptionDiscount: 'SetFullOptionDiscount',
    ViewHwDetails: 'ViewHWDetails',
    SetFullTariffDiscount: 'SetFullTariffDiscount',
    SetOptionDiscount: 'SetOptionDiscount',
    SetHwDiscount: 'SetHWDiscount',
    LockOffer: 'LockOffer',
    ViewOfferCalcPreview: 'ViewOfferCalcPreview',
    SetOfferOptMsg: 'SetOfferOptMsg',
    ChangeOfferWpTotal: 'ChangeOfferWPTotal',
    ChangeStatusWhileInApproval: 'ChangeStatusWhileInApproval',
    PrintUnapprovedOffer: 'PrintUnapprovedOffer',
    CopyOffer: 'CopyOffer',
    ApproveOffer: 'ApproveOffer',
    RequireOfferApproval: 'RequireOfferApproval',
    EditOfferNotes: 'EditOfferNotes',
    ViewOfferWarning: 'ViewOfferWarning',
    ViewReportBudget: 'ViewReportBudget',
    UpdateOffer: 'UpdateOffer',
    CreateOffer: 'CreateOffer',
    ExportReport: 'ExportReport',
    ChangeConfiguration: 'ChangeConfiguration',
    GetAllOffers: 'GetAllOffers',
    GetHisOffer: 'GetHisOffer',
    GetSubOffers: 'GetSubOffers',
    SeeRoaming: 'SeeRoaming'
};
/**
 *
 * @export
 * @enum {string}
 */
export var BetweenOper = {
    None: 'None',
    Add: 'Add',
    Minus: 'Minus',
    Times: 'Times',
    Divide: 'Divide',
    Stack: 'Stack'
};
/**
 *
 * @export
 * @enum {string}
 */
export var CalcType = {
    Standard: 'Standard'
};
/**
 *
 * @export
 * @enum {string}
 */
export var CallingConventions = {
    Standard: 'Standard',
    VarArgs: 'VarArgs',
    Any: 'Any',
    HasThis: 'HasThis',
    ExplicitThis: 'ExplicitThis'
};
/**
 *
 * @export
 * @enum {string}
 */
export var CommentType = {
    Info: 'Info',
    Price: 'Price',
    Installation: 'Installation'
};
/**
 *
 * @export
 * @enum {string}
 */
export var CustomFieldSectionType = {
    Flat: 'Flat',
    Nested: 'Nested'
};
/**
 *
 * @export
 * @enum {string}
 */
export var CustomFieldType = {
    Text: 'Text',
    LongText: 'LongText',
    Number: 'Number',
    Percentage: 'Percentage',
    Currency: 'Currency',
    Date: 'Date',
    DateTime: 'DateTime',
    Checkbox: 'Checkbox',
    SingleSelect: 'SingleSelect',
    MultiSelect: 'MultiSelect',
    Email: 'Email',
    File: 'File'
};
/**
 *
 * @export
 * @enum {string}
 */
export var EventAttributes = {
    None: 'None',
    SpecialName: 'SpecialName',
    RtSpecialName: 'RTSpecialName'
};
/**
 *
 * @export
 * @enum {string}
 */
export var FieldAttributes = {
    PrivateScope: 'PrivateScope',
    Private: 'Private',
    FamAndAssem: 'FamANDAssem',
    Assembly: 'Assembly',
    Family: 'Family',
    FamOrAssem: 'FamORAssem',
    Public: 'Public',
    FieldAccessMask: 'FieldAccessMask',
    Static: 'Static',
    InitOnly: 'InitOnly',
    Literal: 'Literal',
    NotSerialized: 'NotSerialized',
    HasFieldRva: 'HasFieldRVA',
    SpecialName: 'SpecialName',
    RtSpecialName: 'RTSpecialName',
    HasFieldMarshal: 'HasFieldMarshal',
    PinvokeImpl: 'PinvokeImpl',
    HasDefault: 'HasDefault',
    ReservedMask: 'ReservedMask'
};
/**
 *
 * @export
 * @enum {string}
 */
export var FilterDuration = {
    All: 'All',
    Day: 'Day',
    Week: 'Week',
    Month: 'Month',
    ThreeMonths: 'ThreeMonths',
    SixMonths: 'SixMonths',
    Year: 'Year'
};
/**
 *
 * @export
 * @enum {string}
 */
export var FormFieldUsage = {
    Default: 'Default',
    Trigger: 'Trigger',
    Result: 'Result'
};
/**
 *
 * @export
 * @enum {string}
 */
export var FunctionOper = {
    Empty: 'Empty',
    Reduce: 'Reduce',
    GetVector: 'GetVector',
    GetRow: 'GetRow',
    Expand: 'Expand',
    Extract: 'Extract',
    Combine: 'Combine',
    Min: 'Min',
    Max: 'Max',
    Round: 'Round'
};
/**
 *
 * @export
 * @enum {string}
 */
export var GenericParameterAttributes = {
    None: 'None',
    Covariant: 'Covariant',
    Contravariant: 'Contravariant',
    VarianceMask: 'VarianceMask',
    ReferenceTypeConstraint: 'ReferenceTypeConstraint',
    NotNullableValueTypeConstraint: 'NotNullableValueTypeConstraint',
    DefaultConstructorConstraint: 'DefaultConstructorConstraint',
    SpecialConstraintMask: 'SpecialConstraintMask'
};
/**
 *
 * @export
 * @enum {string}
 */
export var LayoutKind = {
    Sequential: 'Sequential',
    Explicit: 'Explicit',
    Auto: 'Auto'
};
/**
 *
 * @export
 * @enum {string}
 */
export var LogLevel = {
    Trace: 'Trace',
    Debug: 'Debug',
    Information: 'Information',
    Warning: 'Warning',
    Error: 'Error',
    Critical: 'Critical',
    None: 'None'
};
/**
 *
 * @export
 * @enum {string}
 */
export var MaintenanceType = {
    Global: 'GLOBAL'
};
/**
 *
 * @export
 * @enum {string}
 */
export var MatrixType = {
    Vector: 'Vector',
    Row: 'Row'
};
/**
 *
 * @export
 * @enum {string}
 */
export var MemberTypes = {
    Constructor: 'Constructor',
    Event: 'Event',
    Field: 'Field',
    Method: 'Method',
    Property: 'Property',
    TypeInfo: 'TypeInfo',
    Custom: 'Custom',
    NestedType: 'NestedType',
    All: 'All'
};
/**
 *
 * @export
 * @enum {string}
 */
export var MethodAttributes = {
    ReuseSlot: 'ReuseSlot',
    Private: 'Private',
    FamAndAssem: 'FamANDAssem',
    Assembly: 'Assembly',
    Family: 'Family',
    FamOrAssem: 'FamORAssem',
    Public: 'Public',
    MemberAccessMask: 'MemberAccessMask',
    UnmanagedExport: 'UnmanagedExport',
    Static: 'Static',
    Final: 'Final',
    Virtual: 'Virtual',
    HideBySig: 'HideBySig',
    NewSlot: 'NewSlot',
    CheckAccessOnOverride: 'CheckAccessOnOverride',
    Abstract: 'Abstract',
    SpecialName: 'SpecialName',
    RtSpecialName: 'RTSpecialName',
    PinvokeImpl: 'PinvokeImpl',
    HasSecurity: 'HasSecurity',
    RequireSecObject: 'RequireSecObject',
    ReservedMask: 'ReservedMask'
};
/**
 *
 * @export
 * @enum {string}
 */
export var MethodImplAttributes = {
    Il: 'IL',
    Native: 'Native',
    Optil: 'OPTIL',
    Runtime: 'Runtime',
    Unmanaged: 'Unmanaged',
    NoInlining: 'NoInlining',
    ForwardRef: 'ForwardRef',
    Synchronized: 'Synchronized',
    NoOptimization: 'NoOptimization',
    PreserveSig: 'PreserveSig',
    AggressiveInlining: 'AggressiveInlining',
    AggressiveOptimization: 'AggressiveOptimization',
    InternalCall: 'InternalCall',
    MaxMethodImplVal: 'MaxMethodImplVal'
};
/**
 *
 * @export
 * @enum {string}
 */
export var MoveDirection = {
    Up: 'Up',
    Down: 'Down'
};
/**
 *
 * @export
 * @enum {string}
 */
export var NotificationStatus = {
    Info: 'Info',
    Warning: 'Warning'
};
/**
 *
 * @export
 * @enum {string}
 */
export var OfferPurpose = {
    Renewal: 'Renewal',
    Acquisition: 'Acquisition',
    AddHw: 'AddHw',
    ChangeTerms: 'ChangeTerms',
    AddSim: 'AddSim'
};
/**
 *
 * @export
 * @enum {string}
 */
export var OfferStage = {
    Draft: 'Draft',
    Prepared: 'Prepared',
    Sent: 'Sent',
    Won: 'Won',
    Lost: 'Lost',
    Canceled: 'Canceled'
};
/**
 *
 * @export
 * @enum {string}
 */
export var OfferState = {
    Open: 'Open',
    WaitingForApproval: 'WaitingForApproval',
    Closed: 'Closed'
};
/**
 *
 * @export
 * @enum {string}
 */
export var OperandDimension = {
    Scalar: 'Scalar',
    Vector: 'Vector',
    Matrix: 'Matrix',
    Tensor: 'Tensor'
};
/**
 *
 * @export
 * @enum {string}
 */
export var OperandType = {
    Variable: 'Variable',
    Parameter: 'Parameter',
    Constant: 'Constant',
    Value: 'Value',
    CustomField: 'CustomField'
};
/**
 *
 * @export
 * @enum {string}
 */
export var OperationBlockType = {
    Calculus: 'Calculus',
    Logical: 'Logical'
};
/**
 *
 * @export
 * @enum {string}
 */
export var OperationType = {
    AggregateOperation: 'AggregateOperation',
    LogicalOperation: 'LogicalOperation',
    FunctionOperation: 'FunctionOperation'
};
/**
 *
 * @export
 * @enum {string}
 */
export var ParameterAttributes = {
    None: 'None',
    In: 'In',
    Out: 'Out',
    Lcid: 'Lcid',
    Retval: 'Retval',
    Optional: 'Optional',
    HasDefault: 'HasDefault',
    HasFieldMarshal: 'HasFieldMarshal',
    Reserved3: 'Reserved3',
    Reserved4: 'Reserved4',
    ReservedMask: 'ReservedMask'
};
/**
 *
 * @export
 * @enum {string}
 */
export var ProductSegment = {
    Sme: 'SME'
};
/**
 *
 * @export
 * @enum {string}
 */
export var PropertyAttributes = {
    None: 'None',
    SpecialName: 'SpecialName',
    RtSpecialName: 'RTSpecialName',
    HasDefault: 'HasDefault',
    Reserved2: 'Reserved2',
    Reserved3: 'Reserved3',
    Reserved4: 'Reserved4',
    ReservedMask: 'ReservedMask'
};
/**
 *
 * @export
 * @enum {string}
 */
export var SaveStatus = {
    Success: 'Success',
    Failure: 'Failure',
    InvalidRequest: 'InvalidRequest'
};
/**
 *
 * @export
 * @enum {string}
 */
export var SecurityRuleSet = {
    None: 'None',
    Level1: 'Level1',
    Level2: 'Level2'
};
/**
 *
 * @export
 * @enum {string}
 */
export var SelectOptionType = {
    Text: 'Text',
    Number: 'Number'
};
/**
 *
 * @export
 * @enum {string}
 */
export var SortOrder = {
    None: 'None',
    Asc: 'Asc',
    Desc: 'Desc'
};
/**
 *
 * @export
 * @enum {string}
 */
export var TrafficType = {
    Voice: 'Voice',
    Sms: 'Sms',
    Data: 'Data'
};
/**
 *
 * @export
 * @enum {string}
 */
export var TypeAttributes = {
    NotPublic: 'NotPublic',
    Public: 'Public',
    NestedPublic: 'NestedPublic',
    NestedPrivate: 'NestedPrivate',
    NestedFamily: 'NestedFamily',
    NestedAssembly: 'NestedAssembly',
    NestedFamAndAssem: 'NestedFamANDAssem',
    NestedFamOrAssem: 'NestedFamORAssem',
    SequentialLayout: 'SequentialLayout',
    ExplicitLayout: 'ExplicitLayout',
    LayoutMask: 'LayoutMask',
    Interface: 'Interface',
    Abstract: 'Abstract',
    Sealed: 'Sealed',
    SpecialName: 'SpecialName',
    RtSpecialName: 'RTSpecialName',
    Import: 'Import',
    Serializable: 'Serializable',
    WindowsRuntime: 'WindowsRuntime',
    UnicodeClass: 'UnicodeClass',
    AutoClass: 'AutoClass',
    CustomFormatClass: 'CustomFormatClass',
    HasSecurity: 'HasSecurity',
    ReservedMask: 'ReservedMask',
    BeforeFieldInit: 'BeforeFieldInit',
    CustomFormatMask: 'CustomFormatMask'
};
/**
 *
 * @export
 * @enum {string}
 */
export var UnitType = {
    Mb: 'MB',
    Mou: 'MOU',
    No: 'No'
};
/**
 *
 * @export
 * @enum {string}
 */
export var UserRole = {
    Manager: 'Manager',
    SalesRep: 'SalesRep',
    Configurator: 'Configurator',
    None: 'None'
};
/**
 *
 * @export
 * @enum {string}
 */
export var ValueType = {
    String: 'String',
    Number: 'Number',
    Boolean: 'Boolean',
    Date: 'Date',
    Range: 'Range',
    Enum: 'Enum'
};
/**
 *
 * @export
 * @enum {string}
 */
export var VariableType = {
    Custom: 'Custom',
    Predefined: 'Predefined',
    Result: 'Result'
};
/**
 * AccountApi - axios parameter creator
 * @export
 */
export var AccountApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountGetAllowedActionsGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/Account/GetAllowedActions";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {LoginRequest} [loginRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountLoginPost: function (loginRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/Account/Login";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(loginRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * AccountApi - functional programming interface
 * @export
 */
export var AccountApiFp = function (configuration) {
    var localVarAxiosParamCreator = AccountApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountGetAllowedActionsGet: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiAccountGetAllowedActionsGet(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['AccountApi.apiAccountGetAllowedActionsGet']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {LoginRequest} [loginRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountLoginPost: function (loginRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiAccountLoginPost(loginRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['AccountApi.apiAccountLoginPost']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
/**
 * AccountApi - factory interface
 * @export
 */
export var AccountApiFactory = function (configuration, basePath, axios) {
    var localVarFp = AccountApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountGetAllowedActionsGet: function (options) {
            return localVarFp.apiAccountGetAllowedActionsGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {LoginRequest} [loginRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAccountLoginPost: function (loginRequest, options) {
            return localVarFp.apiAccountLoginPost(loginRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * AccountApi - object-oriented interface
 * @export
 * @class AccountApi
 * @extends {BaseAPI}
 */
var AccountApi = /** @class */ (function (_super) {
    __extends(AccountApi, _super);
    function AccountApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    AccountApi.prototype.apiAccountGetAllowedActionsGet = function (options) {
        var _this = this;
        return AccountApiFp(this.configuration).apiAccountGetAllowedActionsGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {LoginRequest} [loginRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    AccountApi.prototype.apiAccountLoginPost = function (loginRequest, options) {
        var _this = this;
        return AccountApiFp(this.configuration).apiAccountLoginPost(loginRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AccountApi;
}(BaseAPI));
export { AccountApi };
/**
 * CalculationDataApi - axios parameter creator
 * @export
 */
export var CalculationDataApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {string} [name]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataConstantByNameGet: function (name, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/CalculationData/ConstantByName";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (name !== undefined) {
                                localVarQueryParameter['Name'] = name;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataConstantGet: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/CalculationData/Constant";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (id !== undefined) {
                                localVarQueryParameter['Id'] = id;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataConstantIdDelete: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            assertParamExists('apiCalculationDataConstantIdDelete', 'id', id);
                            localVarPath = "/api/CalculationData/Constant/{Id}"
                                .replace("{".concat("Id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {Constant} [constant]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataConstantIdPut: function (id, constant, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            assertParamExists('apiCalculationDataConstantIdPut', 'id', id);
                            localVarPath = "/api/CalculationData/Constant/{Id}"
                                .replace("{".concat("Id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(constant, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {Constant} [constant]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataConstantPost: function (constant, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/CalculationData/Constant";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(constant, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {CalcType} [calcType]
         * @param {string} [name]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataCopyRuleIdPost: function (id, calcType, name, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            assertParamExists('apiCalculationDataCopyRuleIdPost', 'id', id);
                            localVarPath = "/api/CalculationData/CopyRule/{Id}"
                                .replace("{".concat("Id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (calcType !== undefined) {
                                localVarQueryParameter['CalcType'] = calcType;
                            }
                            if (name !== undefined) {
                                localVarQueryParameter['Name'] = name;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataDefinitionsIdGet: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            assertParamExists('apiCalculationDataDefinitionsIdGet', 'id', id);
                            localVarPath = "/api/CalculationData/Definitions/{Id}"
                                .replace("{".concat("Id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataFormulaIdDelete: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            assertParamExists('apiCalculationDataFormulaIdDelete', 'id', id);
                            localVarPath = "/api/CalculationData/Formula/{Id}"
                                .replace("{".concat("Id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataFormulaIdGet: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            assertParamExists('apiCalculationDataFormulaIdGet', 'id', id);
                            localVarPath = "/api/CalculationData/Formula/{Id}"
                                .replace("{".concat("Id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {Formula} [formula]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataFormulaIdPost: function (id, formula, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            assertParamExists('apiCalculationDataFormulaIdPost', 'id', id);
                            localVarPath = "/api/CalculationData/Formula/{Id}"
                                .replace("{".concat("Id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(formula, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} ruleId
         * @param {Formula} [formula]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataFormulaRuleIdPut: function (ruleId, formula, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'ruleId' is not null or undefined
                            assertParamExists('apiCalculationDataFormulaRuleIdPut', 'ruleId', ruleId);
                            localVarPath = "/api/CalculationData/Formula/{RuleId}"
                                .replace("{".concat("RuleId", "}"), encodeURIComponent(String(ruleId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(formula, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} ruleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataFormulaeRuleIdGet: function (ruleId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'ruleId' is not null or undefined
                            assertParamExists('apiCalculationDataFormulaeRuleIdGet', 'ruleId', ruleId);
                            localVarPath = "/api/CalculationData/Formulae/{RuleId}"
                                .replace("{".concat("RuleId", "}"), encodeURIComponent(String(ruleId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataGetConstantsGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/CalculationData/GetConstants";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {CalcType} [calcType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataGetFormFieldsGet: function (calcType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/CalculationData/GetFormFields";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (calcType !== undefined) {
                                localVarQueryParameter['calcType'] = calcType;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataGetOperationsGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/CalculationData/GetOperations";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {CalcType} [calcType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataGetParametersGet: function (calcType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/CalculationData/GetParameters";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (calcType !== undefined) {
                                localVarQueryParameter['calcType'] = calcType;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {CalcType} [calcType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataGetVariablesGet: function (calcType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/CalculationData/GetVariables";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (calcType !== undefined) {
                                localVarQueryParameter['calcType'] = calcType;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {MoveDirection} direction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataMoveFormulaIdDirectionPost: function (id, direction, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            assertParamExists('apiCalculationDataMoveFormulaIdDirectionPost', 'id', id);
                            // verify required parameter 'direction' is not null or undefined
                            assertParamExists('apiCalculationDataMoveFormulaIdDirectionPost', 'direction', direction);
                            localVarPath = "/api/CalculationData/MoveFormula/{Id}/{direction}"
                                .replace("{".concat("Id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("direction", "}"), encodeURIComponent(String(direction)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {MoveDirection} direction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataMoveRuleIdDirectionPost: function (id, direction, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            assertParamExists('apiCalculationDataMoveRuleIdDirectionPost', 'id', id);
                            // verify required parameter 'direction' is not null or undefined
                            assertParamExists('apiCalculationDataMoveRuleIdDirectionPost', 'direction', direction);
                            localVarPath = "/api/CalculationData/MoveRule/{Id}/{direction}"
                                .replace("{".concat("Id", "}"), encodeURIComponent(String(id)))
                                .replace("{".concat("direction", "}"), encodeURIComponent(String(direction)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {Offer} [offer]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataOfferCalculationPost: function (offer, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/CalculationData/OfferCalculation";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(offer, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {CalculationReq} [calculationReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataOfferTestPost: function (calculationReq, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/CalculationData/OfferTest";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(calculationReq, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataRuleIdDelete: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            assertParamExists('apiCalculationDataRuleIdDelete', 'id', id);
                            localVarPath = "/api/CalculationData/Rule/{Id}"
                                .replace("{".concat("Id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataRuleIdGet: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            assertParamExists('apiCalculationDataRuleIdGet', 'id', id);
                            localVarPath = "/api/CalculationData/Rule/{Id}"
                                .replace("{".concat("Id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {Rule} [rule]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataRuleIdPost: function (id, rule, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            assertParamExists('apiCalculationDataRuleIdPost', 'id', id);
                            localVarPath = "/api/CalculationData/Rule/{Id}"
                                .replace("{".concat("Id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(rule, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {Rule} [rule]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataRulePut: function (rule, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/CalculationData/Rule";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(rule, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {CalcType} calcType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataRulesCalcTypeGet: function (calcType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'calcType' is not null or undefined
                            assertParamExists('apiCalculationDataRulesCalcTypeGet', 'calcType', calcType);
                            localVarPath = "/api/CalculationData/Rules/{CalcType}"
                                .replace("{".concat("CalcType", "}"), encodeURIComponent(String(calcType)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {Rule} [rule]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataTestRulePost: function (rule, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/CalculationData/TestRule";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(rule, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * CalculationDataApi - functional programming interface
 * @export
 */
export var CalculationDataApiFp = function (configuration) {
    var localVarAxiosParamCreator = CalculationDataApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} [name]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataConstantByNameGet: function (name, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiCalculationDataConstantByNameGet(name, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['CalculationDataApi.apiCalculationDataConstantByNameGet']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataConstantGet: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiCalculationDataConstantGet(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['CalculationDataApi.apiCalculationDataConstantGet']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataConstantIdDelete: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiCalculationDataConstantIdDelete(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['CalculationDataApi.apiCalculationDataConstantIdDelete']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {Constant} [constant]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataConstantIdPut: function (id, constant, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiCalculationDataConstantIdPut(id, constant, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['CalculationDataApi.apiCalculationDataConstantIdPut']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {Constant} [constant]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataConstantPost: function (constant, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiCalculationDataConstantPost(constant, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['CalculationDataApi.apiCalculationDataConstantPost']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {CalcType} [calcType]
         * @param {string} [name]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataCopyRuleIdPost: function (id, calcType, name, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiCalculationDataCopyRuleIdPost(id, calcType, name, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['CalculationDataApi.apiCalculationDataCopyRuleIdPost']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataDefinitionsIdGet: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiCalculationDataDefinitionsIdGet(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['CalculationDataApi.apiCalculationDataDefinitionsIdGet']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataFormulaIdDelete: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiCalculationDataFormulaIdDelete(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['CalculationDataApi.apiCalculationDataFormulaIdDelete']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataFormulaIdGet: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiCalculationDataFormulaIdGet(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['CalculationDataApi.apiCalculationDataFormulaIdGet']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {Formula} [formula]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataFormulaIdPost: function (id, formula, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiCalculationDataFormulaIdPost(id, formula, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['CalculationDataApi.apiCalculationDataFormulaIdPost']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} ruleId
         * @param {Formula} [formula]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataFormulaRuleIdPut: function (ruleId, formula, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiCalculationDataFormulaRuleIdPut(ruleId, formula, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['CalculationDataApi.apiCalculationDataFormulaRuleIdPut']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} ruleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataFormulaeRuleIdGet: function (ruleId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiCalculationDataFormulaeRuleIdGet(ruleId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['CalculationDataApi.apiCalculationDataFormulaeRuleIdGet']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataGetConstantsGet: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiCalculationDataGetConstantsGet(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['CalculationDataApi.apiCalculationDataGetConstantsGet']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {CalcType} [calcType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataGetFormFieldsGet: function (calcType, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiCalculationDataGetFormFieldsGet(calcType, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['CalculationDataApi.apiCalculationDataGetFormFieldsGet']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataGetOperationsGet: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiCalculationDataGetOperationsGet(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['CalculationDataApi.apiCalculationDataGetOperationsGet']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {CalcType} [calcType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataGetParametersGet: function (calcType, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiCalculationDataGetParametersGet(calcType, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['CalculationDataApi.apiCalculationDataGetParametersGet']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {CalcType} [calcType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataGetVariablesGet: function (calcType, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiCalculationDataGetVariablesGet(calcType, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['CalculationDataApi.apiCalculationDataGetVariablesGet']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {MoveDirection} direction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataMoveFormulaIdDirectionPost: function (id, direction, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiCalculationDataMoveFormulaIdDirectionPost(id, direction, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['CalculationDataApi.apiCalculationDataMoveFormulaIdDirectionPost']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {MoveDirection} direction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataMoveRuleIdDirectionPost: function (id, direction, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiCalculationDataMoveRuleIdDirectionPost(id, direction, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['CalculationDataApi.apiCalculationDataMoveRuleIdDirectionPost']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {Offer} [offer]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataOfferCalculationPost: function (offer, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiCalculationDataOfferCalculationPost(offer, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['CalculationDataApi.apiCalculationDataOfferCalculationPost']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {CalculationReq} [calculationReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataOfferTestPost: function (calculationReq, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiCalculationDataOfferTestPost(calculationReq, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['CalculationDataApi.apiCalculationDataOfferTestPost']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataRuleIdDelete: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiCalculationDataRuleIdDelete(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['CalculationDataApi.apiCalculationDataRuleIdDelete']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataRuleIdGet: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiCalculationDataRuleIdGet(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['CalculationDataApi.apiCalculationDataRuleIdGet']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {Rule} [rule]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataRuleIdPost: function (id, rule, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiCalculationDataRuleIdPost(id, rule, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['CalculationDataApi.apiCalculationDataRuleIdPost']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {Rule} [rule]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataRulePut: function (rule, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiCalculationDataRulePut(rule, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['CalculationDataApi.apiCalculationDataRulePut']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {CalcType} calcType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataRulesCalcTypeGet: function (calcType, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiCalculationDataRulesCalcTypeGet(calcType, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['CalculationDataApi.apiCalculationDataRulesCalcTypeGet']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {Rule} [rule]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataTestRulePost: function (rule, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiCalculationDataTestRulePost(rule, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['CalculationDataApi.apiCalculationDataTestRulePost']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
/**
 * CalculationDataApi - factory interface
 * @export
 */
export var CalculationDataApiFactory = function (configuration, basePath, axios) {
    var localVarFp = CalculationDataApiFp(configuration);
    return {
        /**
         *
         * @param {string} [name]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataConstantByNameGet: function (name, options) {
            return localVarFp.apiCalculationDataConstantByNameGet(name, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataConstantGet: function (id, options) {
            return localVarFp.apiCalculationDataConstantGet(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataConstantIdDelete: function (id, options) {
            return localVarFp.apiCalculationDataConstantIdDelete(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} id
         * @param {Constant} [constant]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataConstantIdPut: function (id, constant, options) {
            return localVarFp.apiCalculationDataConstantIdPut(id, constant, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {Constant} [constant]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataConstantPost: function (constant, options) {
            return localVarFp.apiCalculationDataConstantPost(constant, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} id
         * @param {CalcType} [calcType]
         * @param {string} [name]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataCopyRuleIdPost: function (id, calcType, name, options) {
            return localVarFp.apiCalculationDataCopyRuleIdPost(id, calcType, name, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataDefinitionsIdGet: function (id, options) {
            return localVarFp.apiCalculationDataDefinitionsIdGet(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataFormulaIdDelete: function (id, options) {
            return localVarFp.apiCalculationDataFormulaIdDelete(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataFormulaIdGet: function (id, options) {
            return localVarFp.apiCalculationDataFormulaIdGet(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} id
         * @param {Formula} [formula]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataFormulaIdPost: function (id, formula, options) {
            return localVarFp.apiCalculationDataFormulaIdPost(id, formula, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} ruleId
         * @param {Formula} [formula]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataFormulaRuleIdPut: function (ruleId, formula, options) {
            return localVarFp.apiCalculationDataFormulaRuleIdPut(ruleId, formula, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} ruleId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataFormulaeRuleIdGet: function (ruleId, options) {
            return localVarFp.apiCalculationDataFormulaeRuleIdGet(ruleId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataGetConstantsGet: function (options) {
            return localVarFp.apiCalculationDataGetConstantsGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {CalcType} [calcType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataGetFormFieldsGet: function (calcType, options) {
            return localVarFp.apiCalculationDataGetFormFieldsGet(calcType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataGetOperationsGet: function (options) {
            return localVarFp.apiCalculationDataGetOperationsGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {CalcType} [calcType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataGetParametersGet: function (calcType, options) {
            return localVarFp.apiCalculationDataGetParametersGet(calcType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {CalcType} [calcType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataGetVariablesGet: function (calcType, options) {
            return localVarFp.apiCalculationDataGetVariablesGet(calcType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} id
         * @param {MoveDirection} direction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataMoveFormulaIdDirectionPost: function (id, direction, options) {
            return localVarFp.apiCalculationDataMoveFormulaIdDirectionPost(id, direction, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} id
         * @param {MoveDirection} direction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataMoveRuleIdDirectionPost: function (id, direction, options) {
            return localVarFp.apiCalculationDataMoveRuleIdDirectionPost(id, direction, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {Offer} [offer]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataOfferCalculationPost: function (offer, options) {
            return localVarFp.apiCalculationDataOfferCalculationPost(offer, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {CalculationReq} [calculationReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataOfferTestPost: function (calculationReq, options) {
            return localVarFp.apiCalculationDataOfferTestPost(calculationReq, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataRuleIdDelete: function (id, options) {
            return localVarFp.apiCalculationDataRuleIdDelete(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataRuleIdGet: function (id, options) {
            return localVarFp.apiCalculationDataRuleIdGet(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} id
         * @param {Rule} [rule]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataRuleIdPost: function (id, rule, options) {
            return localVarFp.apiCalculationDataRuleIdPost(id, rule, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {Rule} [rule]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataRulePut: function (rule, options) {
            return localVarFp.apiCalculationDataRulePut(rule, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {CalcType} calcType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataRulesCalcTypeGet: function (calcType, options) {
            return localVarFp.apiCalculationDataRulesCalcTypeGet(calcType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {Rule} [rule]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculationDataTestRulePost: function (rule, options) {
            return localVarFp.apiCalculationDataTestRulePost(rule, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * CalculationDataApi - object-oriented interface
 * @export
 * @class CalculationDataApi
 * @extends {BaseAPI}
 */
var CalculationDataApi = /** @class */ (function (_super) {
    __extends(CalculationDataApi, _super);
    function CalculationDataApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {string} [name]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculationDataApi
     */
    CalculationDataApi.prototype.apiCalculationDataConstantByNameGet = function (name, options) {
        var _this = this;
        return CalculationDataApiFp(this.configuration).apiCalculationDataConstantByNameGet(name, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculationDataApi
     */
    CalculationDataApi.prototype.apiCalculationDataConstantGet = function (id, options) {
        var _this = this;
        return CalculationDataApiFp(this.configuration).apiCalculationDataConstantGet(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculationDataApi
     */
    CalculationDataApi.prototype.apiCalculationDataConstantIdDelete = function (id, options) {
        var _this = this;
        return CalculationDataApiFp(this.configuration).apiCalculationDataConstantIdDelete(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} id
     * @param {Constant} [constant]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculationDataApi
     */
    CalculationDataApi.prototype.apiCalculationDataConstantIdPut = function (id, constant, options) {
        var _this = this;
        return CalculationDataApiFp(this.configuration).apiCalculationDataConstantIdPut(id, constant, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {Constant} [constant]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculationDataApi
     */
    CalculationDataApi.prototype.apiCalculationDataConstantPost = function (constant, options) {
        var _this = this;
        return CalculationDataApiFp(this.configuration).apiCalculationDataConstantPost(constant, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} id
     * @param {CalcType} [calcType]
     * @param {string} [name]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculationDataApi
     */
    CalculationDataApi.prototype.apiCalculationDataCopyRuleIdPost = function (id, calcType, name, options) {
        var _this = this;
        return CalculationDataApiFp(this.configuration).apiCalculationDataCopyRuleIdPost(id, calcType, name, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculationDataApi
     */
    CalculationDataApi.prototype.apiCalculationDataDefinitionsIdGet = function (id, options) {
        var _this = this;
        return CalculationDataApiFp(this.configuration).apiCalculationDataDefinitionsIdGet(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculationDataApi
     */
    CalculationDataApi.prototype.apiCalculationDataFormulaIdDelete = function (id, options) {
        var _this = this;
        return CalculationDataApiFp(this.configuration).apiCalculationDataFormulaIdDelete(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculationDataApi
     */
    CalculationDataApi.prototype.apiCalculationDataFormulaIdGet = function (id, options) {
        var _this = this;
        return CalculationDataApiFp(this.configuration).apiCalculationDataFormulaIdGet(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} id
     * @param {Formula} [formula]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculationDataApi
     */
    CalculationDataApi.prototype.apiCalculationDataFormulaIdPost = function (id, formula, options) {
        var _this = this;
        return CalculationDataApiFp(this.configuration).apiCalculationDataFormulaIdPost(id, formula, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} ruleId
     * @param {Formula} [formula]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculationDataApi
     */
    CalculationDataApi.prototype.apiCalculationDataFormulaRuleIdPut = function (ruleId, formula, options) {
        var _this = this;
        return CalculationDataApiFp(this.configuration).apiCalculationDataFormulaRuleIdPut(ruleId, formula, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} ruleId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculationDataApi
     */
    CalculationDataApi.prototype.apiCalculationDataFormulaeRuleIdGet = function (ruleId, options) {
        var _this = this;
        return CalculationDataApiFp(this.configuration).apiCalculationDataFormulaeRuleIdGet(ruleId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculationDataApi
     */
    CalculationDataApi.prototype.apiCalculationDataGetConstantsGet = function (options) {
        var _this = this;
        return CalculationDataApiFp(this.configuration).apiCalculationDataGetConstantsGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {CalcType} [calcType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculationDataApi
     */
    CalculationDataApi.prototype.apiCalculationDataGetFormFieldsGet = function (calcType, options) {
        var _this = this;
        return CalculationDataApiFp(this.configuration).apiCalculationDataGetFormFieldsGet(calcType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculationDataApi
     */
    CalculationDataApi.prototype.apiCalculationDataGetOperationsGet = function (options) {
        var _this = this;
        return CalculationDataApiFp(this.configuration).apiCalculationDataGetOperationsGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {CalcType} [calcType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculationDataApi
     */
    CalculationDataApi.prototype.apiCalculationDataGetParametersGet = function (calcType, options) {
        var _this = this;
        return CalculationDataApiFp(this.configuration).apiCalculationDataGetParametersGet(calcType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {CalcType} [calcType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculationDataApi
     */
    CalculationDataApi.prototype.apiCalculationDataGetVariablesGet = function (calcType, options) {
        var _this = this;
        return CalculationDataApiFp(this.configuration).apiCalculationDataGetVariablesGet(calcType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} id
     * @param {MoveDirection} direction
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculationDataApi
     */
    CalculationDataApi.prototype.apiCalculationDataMoveFormulaIdDirectionPost = function (id, direction, options) {
        var _this = this;
        return CalculationDataApiFp(this.configuration).apiCalculationDataMoveFormulaIdDirectionPost(id, direction, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} id
     * @param {MoveDirection} direction
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculationDataApi
     */
    CalculationDataApi.prototype.apiCalculationDataMoveRuleIdDirectionPost = function (id, direction, options) {
        var _this = this;
        return CalculationDataApiFp(this.configuration).apiCalculationDataMoveRuleIdDirectionPost(id, direction, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {Offer} [offer]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculationDataApi
     */
    CalculationDataApi.prototype.apiCalculationDataOfferCalculationPost = function (offer, options) {
        var _this = this;
        return CalculationDataApiFp(this.configuration).apiCalculationDataOfferCalculationPost(offer, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {CalculationReq} [calculationReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculationDataApi
     */
    CalculationDataApi.prototype.apiCalculationDataOfferTestPost = function (calculationReq, options) {
        var _this = this;
        return CalculationDataApiFp(this.configuration).apiCalculationDataOfferTestPost(calculationReq, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculationDataApi
     */
    CalculationDataApi.prototype.apiCalculationDataRuleIdDelete = function (id, options) {
        var _this = this;
        return CalculationDataApiFp(this.configuration).apiCalculationDataRuleIdDelete(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculationDataApi
     */
    CalculationDataApi.prototype.apiCalculationDataRuleIdGet = function (id, options) {
        var _this = this;
        return CalculationDataApiFp(this.configuration).apiCalculationDataRuleIdGet(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} id
     * @param {Rule} [rule]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculationDataApi
     */
    CalculationDataApi.prototype.apiCalculationDataRuleIdPost = function (id, rule, options) {
        var _this = this;
        return CalculationDataApiFp(this.configuration).apiCalculationDataRuleIdPost(id, rule, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {Rule} [rule]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculationDataApi
     */
    CalculationDataApi.prototype.apiCalculationDataRulePut = function (rule, options) {
        var _this = this;
        return CalculationDataApiFp(this.configuration).apiCalculationDataRulePut(rule, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {CalcType} calcType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculationDataApi
     */
    CalculationDataApi.prototype.apiCalculationDataRulesCalcTypeGet = function (calcType, options) {
        var _this = this;
        return CalculationDataApiFp(this.configuration).apiCalculationDataRulesCalcTypeGet(calcType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {Rule} [rule]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculationDataApi
     */
    CalculationDataApi.prototype.apiCalculationDataTestRulePost = function (rule, options) {
        var _this = this;
        return CalculationDataApiFp(this.configuration).apiCalculationDataTestRulePost(rule, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CalculationDataApi;
}(BaseAPI));
export { CalculationDataApi };
/**
 * CalculatorApi - axios parameter creator
 * @export
 */
export var CalculatorApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {CalculationRequest} [calculationRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculatorPost: function (calculationRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/Calculator";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(calculationRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * CalculatorApi - functional programming interface
 * @export
 */
export var CalculatorApiFp = function (configuration) {
    var localVarAxiosParamCreator = CalculatorApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {CalculationRequest} [calculationRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculatorPost: function (calculationRequest, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiCalculatorPost(calculationRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['CalculatorApi.apiCalculatorPost']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
/**
 * CalculatorApi - factory interface
 * @export
 */
export var CalculatorApiFactory = function (configuration, basePath, axios) {
    var localVarFp = CalculatorApiFp(configuration);
    return {
        /**
         *
         * @param {CalculationRequest} [calculationRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCalculatorPost: function (calculationRequest, options) {
            return localVarFp.apiCalculatorPost(calculationRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * CalculatorApi - object-oriented interface
 * @export
 * @class CalculatorApi
 * @extends {BaseAPI}
 */
var CalculatorApi = /** @class */ (function (_super) {
    __extends(CalculatorApi, _super);
    function CalculatorApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {CalculationRequest} [calculationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalculatorApi
     */
    CalculatorApi.prototype.apiCalculatorPost = function (calculationRequest, options) {
        var _this = this;
        return CalculatorApiFp(this.configuration).apiCalculatorPost(calculationRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CalculatorApi;
}(BaseAPI));
export { CalculatorApi };
/**
 * ConfigurationApi - axios parameter creator
 * @export
 */
export var ConfigurationApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConfigurationOfferTypeGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/Configuration/OfferType";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConfigurationOfferTypeIdGet: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            assertParamExists('apiConfigurationOfferTypeIdGet', 'id', id);
                            localVarPath = "/api/Configuration/OfferType/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {OfferTypeUpdate} [offerTypeUpdate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConfigurationOfferTypeIdPut: function (id, offerTypeUpdate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            assertParamExists('apiConfigurationOfferTypeIdPut', 'id', id);
                            localVarPath = "/api/Configuration/OfferType/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(offerTypeUpdate, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {OfferTypeCreate} [offerTypeCreate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConfigurationOfferTypePost: function (offerTypeCreate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/Configuration/OfferType";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(offerTypeCreate, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConfigurationOptionTypeGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/Configuration/OptionType";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConfigurationOptionTypeIdGet: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            assertParamExists('apiConfigurationOptionTypeIdGet', 'id', id);
                            localVarPath = "/api/Configuration/OptionType/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {OptionTypeUpdate} [optionTypeUpdate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConfigurationOptionTypeIdPut: function (id, optionTypeUpdate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            assertParamExists('apiConfigurationOptionTypeIdPut', 'id', id);
                            localVarPath = "/api/Configuration/OptionType/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(optionTypeUpdate, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {OptionTypeCreate} [optionTypeCreate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConfigurationOptionTypePost: function (optionTypeCreate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/Configuration/OptionType";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(optionTypeCreate, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConfigurationProductCategoryGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/Configuration/ProductCategory";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConfigurationProductCategoryIdGet: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            assertParamExists('apiConfigurationProductCategoryIdGet', 'id', id);
                            localVarPath = "/api/Configuration/ProductCategory/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * ConfigurationApi - functional programming interface
 * @export
 */
export var ConfigurationApiFp = function (configuration) {
    var localVarAxiosParamCreator = ConfigurationApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConfigurationOfferTypeGet: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiConfigurationOfferTypeGet(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['ConfigurationApi.apiConfigurationOfferTypeGet']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConfigurationOfferTypeIdGet: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiConfigurationOfferTypeIdGet(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['ConfigurationApi.apiConfigurationOfferTypeIdGet']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {OfferTypeUpdate} [offerTypeUpdate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConfigurationOfferTypeIdPut: function (id, offerTypeUpdate, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiConfigurationOfferTypeIdPut(id, offerTypeUpdate, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['ConfigurationApi.apiConfigurationOfferTypeIdPut']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {OfferTypeCreate} [offerTypeCreate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConfigurationOfferTypePost: function (offerTypeCreate, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiConfigurationOfferTypePost(offerTypeCreate, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['ConfigurationApi.apiConfigurationOfferTypePost']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConfigurationOptionTypeGet: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiConfigurationOptionTypeGet(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['ConfigurationApi.apiConfigurationOptionTypeGet']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConfigurationOptionTypeIdGet: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiConfigurationOptionTypeIdGet(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['ConfigurationApi.apiConfigurationOptionTypeIdGet']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {OptionTypeUpdate} [optionTypeUpdate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConfigurationOptionTypeIdPut: function (id, optionTypeUpdate, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiConfigurationOptionTypeIdPut(id, optionTypeUpdate, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['ConfigurationApi.apiConfigurationOptionTypeIdPut']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {OptionTypeCreate} [optionTypeCreate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConfigurationOptionTypePost: function (optionTypeCreate, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiConfigurationOptionTypePost(optionTypeCreate, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['ConfigurationApi.apiConfigurationOptionTypePost']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConfigurationProductCategoryGet: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiConfigurationProductCategoryGet(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['ConfigurationApi.apiConfigurationProductCategoryGet']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConfigurationProductCategoryIdGet: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiConfigurationProductCategoryIdGet(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['ConfigurationApi.apiConfigurationProductCategoryIdGet']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
/**
 * ConfigurationApi - factory interface
 * @export
 */
export var ConfigurationApiFactory = function (configuration, basePath, axios) {
    var localVarFp = ConfigurationApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConfigurationOfferTypeGet: function (options) {
            return localVarFp.apiConfigurationOfferTypeGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConfigurationOfferTypeIdGet: function (id, options) {
            return localVarFp.apiConfigurationOfferTypeIdGet(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} id
         * @param {OfferTypeUpdate} [offerTypeUpdate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConfigurationOfferTypeIdPut: function (id, offerTypeUpdate, options) {
            return localVarFp.apiConfigurationOfferTypeIdPut(id, offerTypeUpdate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {OfferTypeCreate} [offerTypeCreate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConfigurationOfferTypePost: function (offerTypeCreate, options) {
            return localVarFp.apiConfigurationOfferTypePost(offerTypeCreate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConfigurationOptionTypeGet: function (options) {
            return localVarFp.apiConfigurationOptionTypeGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConfigurationOptionTypeIdGet: function (id, options) {
            return localVarFp.apiConfigurationOptionTypeIdGet(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} id
         * @param {OptionTypeUpdate} [optionTypeUpdate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConfigurationOptionTypeIdPut: function (id, optionTypeUpdate, options) {
            return localVarFp.apiConfigurationOptionTypeIdPut(id, optionTypeUpdate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {OptionTypeCreate} [optionTypeCreate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConfigurationOptionTypePost: function (optionTypeCreate, options) {
            return localVarFp.apiConfigurationOptionTypePost(optionTypeCreate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConfigurationProductCategoryGet: function (options) {
            return localVarFp.apiConfigurationProductCategoryGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiConfigurationProductCategoryIdGet: function (id, options) {
            return localVarFp.apiConfigurationProductCategoryIdGet(id, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * ConfigurationApi - object-oriented interface
 * @export
 * @class ConfigurationApi
 * @extends {BaseAPI}
 */
var ConfigurationApi = /** @class */ (function (_super) {
    __extends(ConfigurationApi, _super);
    function ConfigurationApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationApi
     */
    ConfigurationApi.prototype.apiConfigurationOfferTypeGet = function (options) {
        var _this = this;
        return ConfigurationApiFp(this.configuration).apiConfigurationOfferTypeGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationApi
     */
    ConfigurationApi.prototype.apiConfigurationOfferTypeIdGet = function (id, options) {
        var _this = this;
        return ConfigurationApiFp(this.configuration).apiConfigurationOfferTypeIdGet(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} id
     * @param {OfferTypeUpdate} [offerTypeUpdate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationApi
     */
    ConfigurationApi.prototype.apiConfigurationOfferTypeIdPut = function (id, offerTypeUpdate, options) {
        var _this = this;
        return ConfigurationApiFp(this.configuration).apiConfigurationOfferTypeIdPut(id, offerTypeUpdate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {OfferTypeCreate} [offerTypeCreate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationApi
     */
    ConfigurationApi.prototype.apiConfigurationOfferTypePost = function (offerTypeCreate, options) {
        var _this = this;
        return ConfigurationApiFp(this.configuration).apiConfigurationOfferTypePost(offerTypeCreate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationApi
     */
    ConfigurationApi.prototype.apiConfigurationOptionTypeGet = function (options) {
        var _this = this;
        return ConfigurationApiFp(this.configuration).apiConfigurationOptionTypeGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationApi
     */
    ConfigurationApi.prototype.apiConfigurationOptionTypeIdGet = function (id, options) {
        var _this = this;
        return ConfigurationApiFp(this.configuration).apiConfigurationOptionTypeIdGet(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} id
     * @param {OptionTypeUpdate} [optionTypeUpdate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationApi
     */
    ConfigurationApi.prototype.apiConfigurationOptionTypeIdPut = function (id, optionTypeUpdate, options) {
        var _this = this;
        return ConfigurationApiFp(this.configuration).apiConfigurationOptionTypeIdPut(id, optionTypeUpdate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {OptionTypeCreate} [optionTypeCreate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationApi
     */
    ConfigurationApi.prototype.apiConfigurationOptionTypePost = function (optionTypeCreate, options) {
        var _this = this;
        return ConfigurationApiFp(this.configuration).apiConfigurationOptionTypePost(optionTypeCreate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationApi
     */
    ConfigurationApi.prototype.apiConfigurationProductCategoryGet = function (options) {
        var _this = this;
        return ConfigurationApiFp(this.configuration).apiConfigurationProductCategoryGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationApi
     */
    ConfigurationApi.prototype.apiConfigurationProductCategoryIdGet = function (id, options) {
        var _this = this;
        return ConfigurationApiFp(this.configuration).apiConfigurationProductCategoryIdGet(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ConfigurationApi;
}(BaseAPI));
export { ConfigurationApi };
/**
 * CustomFieldDefinitionApi - axios parameter creator
 * @export
 */
export var CustomFieldDefinitionApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomFieldDefinitionGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/CustomFieldDefinition";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomFieldDefinitionIdDelete: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            assertParamExists('apiCustomFieldDefinitionIdDelete', 'id', id);
                            localVarPath = "/api/CustomFieldDefinition/{Id}"
                                .replace("{".concat("Id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomFieldDefinitionIdGet: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            assertParamExists('apiCustomFieldDefinitionIdGet', 'id', id);
                            localVarPath = "/api/CustomFieldDefinition/{Id}"
                                .replace("{".concat("Id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {CustomFieldDefinition} [customFieldDefinition]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomFieldDefinitionIdPut: function (id, customFieldDefinition, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            assertParamExists('apiCustomFieldDefinitionIdPut', 'id', id);
                            localVarPath = "/api/CustomFieldDefinition/{Id}"
                                .replace("{".concat("Id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(customFieldDefinition, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {CustomFieldDefinition} [customFieldDefinition]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomFieldDefinitionPost: function (customFieldDefinition, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/CustomFieldDefinition";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(customFieldDefinition, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * CustomFieldDefinitionApi - functional programming interface
 * @export
 */
export var CustomFieldDefinitionApiFp = function (configuration) {
    var localVarAxiosParamCreator = CustomFieldDefinitionApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomFieldDefinitionGet: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiCustomFieldDefinitionGet(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['CustomFieldDefinitionApi.apiCustomFieldDefinitionGet']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomFieldDefinitionIdDelete: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiCustomFieldDefinitionIdDelete(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['CustomFieldDefinitionApi.apiCustomFieldDefinitionIdDelete']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomFieldDefinitionIdGet: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiCustomFieldDefinitionIdGet(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['CustomFieldDefinitionApi.apiCustomFieldDefinitionIdGet']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {CustomFieldDefinition} [customFieldDefinition]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomFieldDefinitionIdPut: function (id, customFieldDefinition, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiCustomFieldDefinitionIdPut(id, customFieldDefinition, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['CustomFieldDefinitionApi.apiCustomFieldDefinitionIdPut']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {CustomFieldDefinition} [customFieldDefinition]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomFieldDefinitionPost: function (customFieldDefinition, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiCustomFieldDefinitionPost(customFieldDefinition, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['CustomFieldDefinitionApi.apiCustomFieldDefinitionPost']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
/**
 * CustomFieldDefinitionApi - factory interface
 * @export
 */
export var CustomFieldDefinitionApiFactory = function (configuration, basePath, axios) {
    var localVarFp = CustomFieldDefinitionApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomFieldDefinitionGet: function (options) {
            return localVarFp.apiCustomFieldDefinitionGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomFieldDefinitionIdDelete: function (id, options) {
            return localVarFp.apiCustomFieldDefinitionIdDelete(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomFieldDefinitionIdGet: function (id, options) {
            return localVarFp.apiCustomFieldDefinitionIdGet(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} id
         * @param {CustomFieldDefinition} [customFieldDefinition]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomFieldDefinitionIdPut: function (id, customFieldDefinition, options) {
            return localVarFp.apiCustomFieldDefinitionIdPut(id, customFieldDefinition, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {CustomFieldDefinition} [customFieldDefinition]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomFieldDefinitionPost: function (customFieldDefinition, options) {
            return localVarFp.apiCustomFieldDefinitionPost(customFieldDefinition, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * CustomFieldDefinitionApi - object-oriented interface
 * @export
 * @class CustomFieldDefinitionApi
 * @extends {BaseAPI}
 */
var CustomFieldDefinitionApi = /** @class */ (function (_super) {
    __extends(CustomFieldDefinitionApi, _super);
    function CustomFieldDefinitionApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomFieldDefinitionApi
     */
    CustomFieldDefinitionApi.prototype.apiCustomFieldDefinitionGet = function (options) {
        var _this = this;
        return CustomFieldDefinitionApiFp(this.configuration).apiCustomFieldDefinitionGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomFieldDefinitionApi
     */
    CustomFieldDefinitionApi.prototype.apiCustomFieldDefinitionIdDelete = function (id, options) {
        var _this = this;
        return CustomFieldDefinitionApiFp(this.configuration).apiCustomFieldDefinitionIdDelete(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomFieldDefinitionApi
     */
    CustomFieldDefinitionApi.prototype.apiCustomFieldDefinitionIdGet = function (id, options) {
        var _this = this;
        return CustomFieldDefinitionApiFp(this.configuration).apiCustomFieldDefinitionIdGet(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} id
     * @param {CustomFieldDefinition} [customFieldDefinition]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomFieldDefinitionApi
     */
    CustomFieldDefinitionApi.prototype.apiCustomFieldDefinitionIdPut = function (id, customFieldDefinition, options) {
        var _this = this;
        return CustomFieldDefinitionApiFp(this.configuration).apiCustomFieldDefinitionIdPut(id, customFieldDefinition, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {CustomFieldDefinition} [customFieldDefinition]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomFieldDefinitionApi
     */
    CustomFieldDefinitionApi.prototype.apiCustomFieldDefinitionPost = function (customFieldDefinition, options) {
        var _this = this;
        return CustomFieldDefinitionApiFp(this.configuration).apiCustomFieldDefinitionPost(customFieldDefinition, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CustomFieldDefinitionApi;
}(BaseAPI));
export { CustomFieldDefinitionApi };
/**
 * CustomFieldSectionApi - axios parameter creator
 * @export
 */
export var CustomFieldSectionApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomFieldSectionGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/CustomFieldSection";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomFieldSectionIdGet: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            assertParamExists('apiCustomFieldSectionIdGet', 'id', id);
                            localVarPath = "/api/CustomFieldSection/{Id}"
                                .replace("{".concat("Id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {CustomFieldSection} [customFieldSection]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomFieldSectionIdPut: function (id, customFieldSection, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            assertParamExists('apiCustomFieldSectionIdPut', 'id', id);
                            localVarPath = "/api/CustomFieldSection/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(customFieldSection, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {CustomFieldSection} [customFieldSection]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomFieldSectionPost: function (customFieldSection, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/CustomFieldSection";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(customFieldSection, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomFieldSectionTemplateGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/CustomFieldSection/template";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * CustomFieldSectionApi - functional programming interface
 * @export
 */
export var CustomFieldSectionApiFp = function (configuration) {
    var localVarAxiosParamCreator = CustomFieldSectionApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomFieldSectionGet: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiCustomFieldSectionGet(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['CustomFieldSectionApi.apiCustomFieldSectionGet']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomFieldSectionIdGet: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiCustomFieldSectionIdGet(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['CustomFieldSectionApi.apiCustomFieldSectionIdGet']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {CustomFieldSection} [customFieldSection]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomFieldSectionIdPut: function (id, customFieldSection, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiCustomFieldSectionIdPut(id, customFieldSection, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['CustomFieldSectionApi.apiCustomFieldSectionIdPut']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {CustomFieldSection} [customFieldSection]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomFieldSectionPost: function (customFieldSection, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiCustomFieldSectionPost(customFieldSection, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['CustomFieldSectionApi.apiCustomFieldSectionPost']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomFieldSectionTemplateGet: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiCustomFieldSectionTemplateGet(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['CustomFieldSectionApi.apiCustomFieldSectionTemplateGet']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
/**
 * CustomFieldSectionApi - factory interface
 * @export
 */
export var CustomFieldSectionApiFactory = function (configuration, basePath, axios) {
    var localVarFp = CustomFieldSectionApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomFieldSectionGet: function (options) {
            return localVarFp.apiCustomFieldSectionGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomFieldSectionIdGet: function (id, options) {
            return localVarFp.apiCustomFieldSectionIdGet(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} id
         * @param {CustomFieldSection} [customFieldSection]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomFieldSectionIdPut: function (id, customFieldSection, options) {
            return localVarFp.apiCustomFieldSectionIdPut(id, customFieldSection, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {CustomFieldSection} [customFieldSection]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomFieldSectionPost: function (customFieldSection, options) {
            return localVarFp.apiCustomFieldSectionPost(customFieldSection, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomFieldSectionTemplateGet: function (options) {
            return localVarFp.apiCustomFieldSectionTemplateGet(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * CustomFieldSectionApi - object-oriented interface
 * @export
 * @class CustomFieldSectionApi
 * @extends {BaseAPI}
 */
var CustomFieldSectionApi = /** @class */ (function (_super) {
    __extends(CustomFieldSectionApi, _super);
    function CustomFieldSectionApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomFieldSectionApi
     */
    CustomFieldSectionApi.prototype.apiCustomFieldSectionGet = function (options) {
        var _this = this;
        return CustomFieldSectionApiFp(this.configuration).apiCustomFieldSectionGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomFieldSectionApi
     */
    CustomFieldSectionApi.prototype.apiCustomFieldSectionIdGet = function (id, options) {
        var _this = this;
        return CustomFieldSectionApiFp(this.configuration).apiCustomFieldSectionIdGet(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} id
     * @param {CustomFieldSection} [customFieldSection]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomFieldSectionApi
     */
    CustomFieldSectionApi.prototype.apiCustomFieldSectionIdPut = function (id, customFieldSection, options) {
        var _this = this;
        return CustomFieldSectionApiFp(this.configuration).apiCustomFieldSectionIdPut(id, customFieldSection, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {CustomFieldSection} [customFieldSection]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomFieldSectionApi
     */
    CustomFieldSectionApi.prototype.apiCustomFieldSectionPost = function (customFieldSection, options) {
        var _this = this;
        return CustomFieldSectionApiFp(this.configuration).apiCustomFieldSectionPost(customFieldSection, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomFieldSectionApi
     */
    CustomFieldSectionApi.prototype.apiCustomFieldSectionTemplateGet = function (options) {
        var _this = this;
        return CustomFieldSectionApiFp(this.configuration).apiCustomFieldSectionTemplateGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CustomFieldSectionApi;
}(BaseAPI));
export { CustomFieldSectionApi };
/**
 * CustomerDataApi - axios parameter creator
 * @export
 */
export var CustomerDataApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {string} [ident]
         * @param {string} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomerDataGet: function (ident, value, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/CustomerData";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (ident !== undefined) {
                                localVarQueryParameter['ident'] = ident;
                            }
                            if (value !== undefined) {
                                localVarQueryParameter['value'] = value;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * CustomerDataApi - functional programming interface
 * @export
 */
export var CustomerDataApiFp = function (configuration) {
    var localVarAxiosParamCreator = CustomerDataApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} [ident]
         * @param {string} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomerDataGet: function (ident, value, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiCustomerDataGet(ident, value, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['CustomerDataApi.apiCustomerDataGet']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
/**
 * CustomerDataApi - factory interface
 * @export
 */
export var CustomerDataApiFactory = function (configuration, basePath, axios) {
    var localVarFp = CustomerDataApiFp(configuration);
    return {
        /**
         *
         * @param {string} [ident]
         * @param {string} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCustomerDataGet: function (ident, value, options) {
            return localVarFp.apiCustomerDataGet(ident, value, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * CustomerDataApi - object-oriented interface
 * @export
 * @class CustomerDataApi
 * @extends {BaseAPI}
 */
var CustomerDataApi = /** @class */ (function (_super) {
    __extends(CustomerDataApi, _super);
    function CustomerDataApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {string} [ident]
     * @param {string} [value]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerDataApi
     */
    CustomerDataApi.prototype.apiCustomerDataGet = function (ident, value, options) {
        var _this = this;
        return CustomerDataApiFp(this.configuration).apiCustomerDataGet(ident, value, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CustomerDataApi;
}(BaseAPI));
export { CustomerDataApi };
/**
 * EligiblityApi - axios parameter creator
 * @export
 */
export var EligiblityApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {number} [tariffId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEligiblityGet: function (tariffId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/Eligiblity";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (tariffId !== undefined) {
                                localVarQueryParameter['tariffId'] = tariffId;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} [tariffId]
         * @param {number} [optionId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEligiblityPost: function (tariffId, optionId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/Eligiblity";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (tariffId !== undefined) {
                                localVarQueryParameter['tariffId'] = tariffId;
                            }
                            if (optionId !== undefined) {
                                localVarQueryParameter['optionId'] = optionId;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * EligiblityApi - functional programming interface
 * @export
 */
export var EligiblityApiFp = function (configuration) {
    var localVarAxiosParamCreator = EligiblityApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} [tariffId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEligiblityGet: function (tariffId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiEligiblityGet(tariffId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['EligiblityApi.apiEligiblityGet']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} [tariffId]
         * @param {number} [optionId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEligiblityPost: function (tariffId, optionId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiEligiblityPost(tariffId, optionId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['EligiblityApi.apiEligiblityPost']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
/**
 * EligiblityApi - factory interface
 * @export
 */
export var EligiblityApiFactory = function (configuration, basePath, axios) {
    var localVarFp = EligiblityApiFp(configuration);
    return {
        /**
         *
         * @param {number} [tariffId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEligiblityGet: function (tariffId, options) {
            return localVarFp.apiEligiblityGet(tariffId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} [tariffId]
         * @param {number} [optionId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEligiblityPost: function (tariffId, optionId, options) {
            return localVarFp.apiEligiblityPost(tariffId, optionId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * EligiblityApi - object-oriented interface
 * @export
 * @class EligiblityApi
 * @extends {BaseAPI}
 */
var EligiblityApi = /** @class */ (function (_super) {
    __extends(EligiblityApi, _super);
    function EligiblityApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {number} [tariffId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EligiblityApi
     */
    EligiblityApi.prototype.apiEligiblityGet = function (tariffId, options) {
        var _this = this;
        return EligiblityApiFp(this.configuration).apiEligiblityGet(tariffId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} [tariffId]
     * @param {number} [optionId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EligiblityApi
     */
    EligiblityApi.prototype.apiEligiblityPost = function (tariffId, optionId, options) {
        var _this = this;
        return EligiblityApiFp(this.configuration).apiEligiblityPost(tariffId, optionId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return EligiblityApi;
}(BaseAPI));
export { EligiblityApi };
/**
 * HardwareDataApi - axios parameter creator
 * @export
 */
export var HardwareDataApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiHardwareDataGet: function (offset, limit, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/HardwareData";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} hwId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiHardwareDataGetByHwIdHwIdGet: function (hwId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'hwId' is not null or undefined
                            assertParamExists('apiHardwareDataGetByHwIdHwIdGet', 'hwId', hwId);
                            localVarPath = "/api/HardwareData/GetByHwId/{HwId}"
                                .replace("{".concat("HwId", "}"), encodeURIComponent(String(hwId)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiHardwareDataGetIdGet: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            assertParamExists('apiHardwareDataGetIdGet', 'id', id);
                            localVarPath = "/api/HardwareData/Get/{Id}"
                                .replace("{".concat("Id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {string} [tariffGroup]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiHardwareDataGetTariffPriceIdGet: function (id, tariffGroup, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            assertParamExists('apiHardwareDataGetTariffPriceIdGet', 'id', id);
                            localVarPath = "/api/HardwareData/GetTariffPrice/{Id}"
                                .replace("{".concat("Id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (tariffGroup !== undefined) {
                                localVarQueryParameter['TariffGroup'] = tariffGroup;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * HardwareDataApi - functional programming interface
 * @export
 */
export var HardwareDataApiFp = function (configuration) {
    var localVarAxiosParamCreator = HardwareDataApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiHardwareDataGet: function (offset, limit, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiHardwareDataGet(offset, limit, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['HardwareDataApi.apiHardwareDataGet']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} hwId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiHardwareDataGetByHwIdHwIdGet: function (hwId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiHardwareDataGetByHwIdHwIdGet(hwId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['HardwareDataApi.apiHardwareDataGetByHwIdHwIdGet']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiHardwareDataGetIdGet: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiHardwareDataGetIdGet(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['HardwareDataApi.apiHardwareDataGetIdGet']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {string} [tariffGroup]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiHardwareDataGetTariffPriceIdGet: function (id, tariffGroup, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiHardwareDataGetTariffPriceIdGet(id, tariffGroup, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['HardwareDataApi.apiHardwareDataGetTariffPriceIdGet']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
/**
 * HardwareDataApi - factory interface
 * @export
 */
export var HardwareDataApiFactory = function (configuration, basePath, axios) {
    var localVarFp = HardwareDataApiFp(configuration);
    return {
        /**
         *
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiHardwareDataGet: function (offset, limit, options) {
            return localVarFp.apiHardwareDataGet(offset, limit, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} hwId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiHardwareDataGetByHwIdHwIdGet: function (hwId, options) {
            return localVarFp.apiHardwareDataGetByHwIdHwIdGet(hwId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiHardwareDataGetIdGet: function (id, options) {
            return localVarFp.apiHardwareDataGetIdGet(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} id
         * @param {string} [tariffGroup]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiHardwareDataGetTariffPriceIdGet: function (id, tariffGroup, options) {
            return localVarFp.apiHardwareDataGetTariffPriceIdGet(id, tariffGroup, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * HardwareDataApi - object-oriented interface
 * @export
 * @class HardwareDataApi
 * @extends {BaseAPI}
 */
var HardwareDataApi = /** @class */ (function (_super) {
    __extends(HardwareDataApi, _super);
    function HardwareDataApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {number} [offset]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HardwareDataApi
     */
    HardwareDataApi.prototype.apiHardwareDataGet = function (offset, limit, options) {
        var _this = this;
        return HardwareDataApiFp(this.configuration).apiHardwareDataGet(offset, limit, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} hwId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HardwareDataApi
     */
    HardwareDataApi.prototype.apiHardwareDataGetByHwIdHwIdGet = function (hwId, options) {
        var _this = this;
        return HardwareDataApiFp(this.configuration).apiHardwareDataGetByHwIdHwIdGet(hwId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HardwareDataApi
     */
    HardwareDataApi.prototype.apiHardwareDataGetIdGet = function (id, options) {
        var _this = this;
        return HardwareDataApiFp(this.configuration).apiHardwareDataGetIdGet(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} id
     * @param {string} [tariffGroup]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HardwareDataApi
     */
    HardwareDataApi.prototype.apiHardwareDataGetTariffPriceIdGet = function (id, tariffGroup, options) {
        var _this = this;
        return HardwareDataApiFp(this.configuration).apiHardwareDataGetTariffPriceIdGet(id, tariffGroup, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return HardwareDataApi;
}(BaseAPI));
export { HardwareDataApi };
/**
 * LogoApi - axios parameter creator
 * @export
 */
export var LogoApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogoGetLogoLinkGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/Logo/GetLogoLink";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * LogoApi - functional programming interface
 * @export
 */
export var LogoApiFp = function (configuration) {
    var localVarAxiosParamCreator = LogoApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogoGetLogoLinkGet: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiLogoGetLogoLinkGet(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['LogoApi.apiLogoGetLogoLinkGet']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
/**
 * LogoApi - factory interface
 * @export
 */
export var LogoApiFactory = function (configuration, basePath, axios) {
    var localVarFp = LogoApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogoGetLogoLinkGet: function (options) {
            return localVarFp.apiLogoGetLogoLinkGet(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * LogoApi - object-oriented interface
 * @export
 * @class LogoApi
 * @extends {BaseAPI}
 */
var LogoApi = /** @class */ (function (_super) {
    __extends(LogoApi, _super);
    function LogoApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogoApi
     */
    LogoApi.prototype.apiLogoGetLogoLinkGet = function (options) {
        var _this = this;
        return LogoApiFp(this.configuration).apiLogoGetLogoLinkGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return LogoApi;
}(BaseAPI));
export { LogoApi };
/**
 * OfferDataApi - axios parameter creator
 * @export
 */
export var OfferDataApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOfferDataGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/OfferData";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {DashboardFilters} [dashboardFilters]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOfferDataGetDashboardDataPost: function (dashboardFilters, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/OfferData/GetDashboardData";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(dashboardFilters, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {DashboardFilters} [dashboardFilters]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOfferDataGetDashboardOffersPost: function (dashboardFilters, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/OfferData/GetDashboardOffers";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(dashboardFilters, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOfferDataIdGet: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            assertParamExists('apiOfferDataIdGet', 'id', id);
                            localVarPath = "/api/OfferData/{Id}"
                                .replace("{".concat("Id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {OfferPatch} [offerPatch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOfferDataIdPatch: function (id, offerPatch, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            assertParamExists('apiOfferDataIdPatch', 'id', id);
                            localVarPath = "/api/OfferData/{Id}"
                                .replace("{".concat("Id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(offerPatch, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {Offer} [offer]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOfferDataIdPut: function (id, offer, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            assertParamExists('apiOfferDataIdPut', 'id', id);
                            localVarPath = "/api/OfferData/{Id}"
                                .replace("{".concat("Id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(offer, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {Offer} [offer]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOfferDataPost: function (offer, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/OfferData";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(offer, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {OfferSearch} [offerSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOfferDataSearchPost: function (offerSearch, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/OfferData/Search";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(offerSearch, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} [id]
         * @param {OfferStage} [stage]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOfferDataStageChangeAllowedGet: function (id, stage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/OfferData/StageChangeAllowed";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (id !== undefined) {
                                localVarQueryParameter['Id'] = id;
                            }
                            if (stage !== undefined) {
                                localVarQueryParameter['stage'] = stage;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOfferDataUnlockIdPost: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            assertParamExists('apiOfferDataUnlockIdPost', 'id', id);
                            localVarPath = "/api/OfferData/Unlock/{Id}"
                                .replace("{".concat("Id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * OfferDataApi - functional programming interface
 * @export
 */
export var OfferDataApiFp = function (configuration) {
    var localVarAxiosParamCreator = OfferDataApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOfferDataGet: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiOfferDataGet(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['OfferDataApi.apiOfferDataGet']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {DashboardFilters} [dashboardFilters]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOfferDataGetDashboardDataPost: function (dashboardFilters, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiOfferDataGetDashboardDataPost(dashboardFilters, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['OfferDataApi.apiOfferDataGetDashboardDataPost']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {DashboardFilters} [dashboardFilters]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOfferDataGetDashboardOffersPost: function (dashboardFilters, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiOfferDataGetDashboardOffersPost(dashboardFilters, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['OfferDataApi.apiOfferDataGetDashboardOffersPost']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOfferDataIdGet: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiOfferDataIdGet(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['OfferDataApi.apiOfferDataIdGet']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {OfferPatch} [offerPatch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOfferDataIdPatch: function (id, offerPatch, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiOfferDataIdPatch(id, offerPatch, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['OfferDataApi.apiOfferDataIdPatch']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {Offer} [offer]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOfferDataIdPut: function (id, offer, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiOfferDataIdPut(id, offer, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['OfferDataApi.apiOfferDataIdPut']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {Offer} [offer]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOfferDataPost: function (offer, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiOfferDataPost(offer, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['OfferDataApi.apiOfferDataPost']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {OfferSearch} [offerSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOfferDataSearchPost: function (offerSearch, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiOfferDataSearchPost(offerSearch, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['OfferDataApi.apiOfferDataSearchPost']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} [id]
         * @param {OfferStage} [stage]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOfferDataStageChangeAllowedGet: function (id, stage, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiOfferDataStageChangeAllowedGet(id, stage, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['OfferDataApi.apiOfferDataStageChangeAllowedGet']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOfferDataUnlockIdPost: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiOfferDataUnlockIdPost(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['OfferDataApi.apiOfferDataUnlockIdPost']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
/**
 * OfferDataApi - factory interface
 * @export
 */
export var OfferDataApiFactory = function (configuration, basePath, axios) {
    var localVarFp = OfferDataApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOfferDataGet: function (options) {
            return localVarFp.apiOfferDataGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {DashboardFilters} [dashboardFilters]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOfferDataGetDashboardDataPost: function (dashboardFilters, options) {
            return localVarFp.apiOfferDataGetDashboardDataPost(dashboardFilters, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {DashboardFilters} [dashboardFilters]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOfferDataGetDashboardOffersPost: function (dashboardFilters, options) {
            return localVarFp.apiOfferDataGetDashboardOffersPost(dashboardFilters, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOfferDataIdGet: function (id, options) {
            return localVarFp.apiOfferDataIdGet(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} id
         * @param {OfferPatch} [offerPatch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOfferDataIdPatch: function (id, offerPatch, options) {
            return localVarFp.apiOfferDataIdPatch(id, offerPatch, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} id
         * @param {Offer} [offer]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOfferDataIdPut: function (id, offer, options) {
            return localVarFp.apiOfferDataIdPut(id, offer, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {Offer} [offer]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOfferDataPost: function (offer, options) {
            return localVarFp.apiOfferDataPost(offer, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {OfferSearch} [offerSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOfferDataSearchPost: function (offerSearch, options) {
            return localVarFp.apiOfferDataSearchPost(offerSearch, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} [id]
         * @param {OfferStage} [stage]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOfferDataStageChangeAllowedGet: function (id, stage, options) {
            return localVarFp.apiOfferDataStageChangeAllowedGet(id, stage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOfferDataUnlockIdPost: function (id, options) {
            return localVarFp.apiOfferDataUnlockIdPost(id, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * OfferDataApi - object-oriented interface
 * @export
 * @class OfferDataApi
 * @extends {BaseAPI}
 */
var OfferDataApi = /** @class */ (function (_super) {
    __extends(OfferDataApi, _super);
    function OfferDataApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OfferDataApi
     */
    OfferDataApi.prototype.apiOfferDataGet = function (options) {
        var _this = this;
        return OfferDataApiFp(this.configuration).apiOfferDataGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {DashboardFilters} [dashboardFilters]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OfferDataApi
     */
    OfferDataApi.prototype.apiOfferDataGetDashboardDataPost = function (dashboardFilters, options) {
        var _this = this;
        return OfferDataApiFp(this.configuration).apiOfferDataGetDashboardDataPost(dashboardFilters, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {DashboardFilters} [dashboardFilters]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OfferDataApi
     */
    OfferDataApi.prototype.apiOfferDataGetDashboardOffersPost = function (dashboardFilters, options) {
        var _this = this;
        return OfferDataApiFp(this.configuration).apiOfferDataGetDashboardOffersPost(dashboardFilters, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OfferDataApi
     */
    OfferDataApi.prototype.apiOfferDataIdGet = function (id, options) {
        var _this = this;
        return OfferDataApiFp(this.configuration).apiOfferDataIdGet(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} id
     * @param {OfferPatch} [offerPatch]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OfferDataApi
     */
    OfferDataApi.prototype.apiOfferDataIdPatch = function (id, offerPatch, options) {
        var _this = this;
        return OfferDataApiFp(this.configuration).apiOfferDataIdPatch(id, offerPatch, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} id
     * @param {Offer} [offer]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OfferDataApi
     */
    OfferDataApi.prototype.apiOfferDataIdPut = function (id, offer, options) {
        var _this = this;
        return OfferDataApiFp(this.configuration).apiOfferDataIdPut(id, offer, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {Offer} [offer]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OfferDataApi
     */
    OfferDataApi.prototype.apiOfferDataPost = function (offer, options) {
        var _this = this;
        return OfferDataApiFp(this.configuration).apiOfferDataPost(offer, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {OfferSearch} [offerSearch]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OfferDataApi
     */
    OfferDataApi.prototype.apiOfferDataSearchPost = function (offerSearch, options) {
        var _this = this;
        return OfferDataApiFp(this.configuration).apiOfferDataSearchPost(offerSearch, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} [id]
     * @param {OfferStage} [stage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OfferDataApi
     */
    OfferDataApi.prototype.apiOfferDataStageChangeAllowedGet = function (id, stage, options) {
        var _this = this;
        return OfferDataApiFp(this.configuration).apiOfferDataStageChangeAllowedGet(id, stage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OfferDataApi
     */
    OfferDataApi.prototype.apiOfferDataUnlockIdPost = function (id, options) {
        var _this = this;
        return OfferDataApiFp(this.configuration).apiOfferDataUnlockIdPost(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return OfferDataApi;
}(BaseAPI));
export { OfferDataApi };
/**
 * OptionDataApi - axios parameter creator
 * @export
 */
export var OptionDataApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionDataGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/OptionData";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionDataIdGet: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            assertParamExists('apiOptionDataIdGet', 'id', id);
                            localVarPath = "/api/OptionData/{Id}"
                                .replace("{".concat("Id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {Option} [option]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionDataIdPut: function (id, option, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            assertParamExists('apiOptionDataIdPut', 'id', id);
                            localVarPath = "/api/OptionData/{Id}"
                                .replace("{".concat("Id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(option, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {Option} [option]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionDataPost: function (option, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/OptionData";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(option, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * OptionDataApi - functional programming interface
 * @export
 */
export var OptionDataApiFp = function (configuration) {
    var localVarAxiosParamCreator = OptionDataApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionDataGet: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiOptionDataGet(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['OptionDataApi.apiOptionDataGet']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionDataIdGet: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiOptionDataIdGet(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['OptionDataApi.apiOptionDataIdGet']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {Option} [option]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionDataIdPut: function (id, option, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiOptionDataIdPut(id, option, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['OptionDataApi.apiOptionDataIdPut']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {Option} [option]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionDataPost: function (option, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiOptionDataPost(option, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['OptionDataApi.apiOptionDataPost']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
/**
 * OptionDataApi - factory interface
 * @export
 */
export var OptionDataApiFactory = function (configuration, basePath, axios) {
    var localVarFp = OptionDataApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionDataGet: function (options) {
            return localVarFp.apiOptionDataGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionDataIdGet: function (id, options) {
            return localVarFp.apiOptionDataIdGet(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} id
         * @param {Option} [option]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionDataIdPut: function (id, option, options) {
            return localVarFp.apiOptionDataIdPut(id, option, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {Option} [option]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOptionDataPost: function (option, options) {
            return localVarFp.apiOptionDataPost(option, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * OptionDataApi - object-oriented interface
 * @export
 * @class OptionDataApi
 * @extends {BaseAPI}
 */
var OptionDataApi = /** @class */ (function (_super) {
    __extends(OptionDataApi, _super);
    function OptionDataApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OptionDataApi
     */
    OptionDataApi.prototype.apiOptionDataGet = function (options) {
        var _this = this;
        return OptionDataApiFp(this.configuration).apiOptionDataGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OptionDataApi
     */
    OptionDataApi.prototype.apiOptionDataIdGet = function (id, options) {
        var _this = this;
        return OptionDataApiFp(this.configuration).apiOptionDataIdGet(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} id
     * @param {Option} [option]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OptionDataApi
     */
    OptionDataApi.prototype.apiOptionDataIdPut = function (id, option, options) {
        var _this = this;
        return OptionDataApiFp(this.configuration).apiOptionDataIdPut(id, option, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {Option} [option]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OptionDataApi
     */
    OptionDataApi.prototype.apiOptionDataPost = function (option, options) {
        var _this = this;
        return OptionDataApiFp(this.configuration).apiOptionDataPost(option, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return OptionDataApi;
}(BaseAPI));
export { OptionDataApi };
/**
 * PortfolioDataApi - axios parameter creator
 * @export
 */
export var PortfolioDataApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {number} id
         * @param {string} [name]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPortfolioDataCopyIdPost: function (id, name, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            assertParamExists('apiPortfolioDataCopyIdPost', 'id', id);
                            localVarPath = "/api/PortfolioData/Copy/{Id}"
                                .replace("{".concat("Id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (name !== undefined) {
                                localVarQueryParameter['Name'] = name;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPortfolioDataGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/PortfolioData";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPortfolioDataGetIdGet: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            assertParamExists('apiPortfolioDataGetIdGet', 'id', id);
                            localVarPath = "/api/PortfolioData/Get/{Id}"
                                .replace("{".concat("Id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {Portfolio} [portfolio]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPortfolioDataIdPut: function (id, portfolio, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            assertParamExists('apiPortfolioDataIdPut', 'id', id);
                            localVarPath = "/api/PortfolioData/{Id}"
                                .replace("{".concat("Id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(portfolio, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {Portfolio} [portfolio]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPortfolioDataPost: function (portfolio, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/PortfolioData";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(portfolio, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * PortfolioDataApi - functional programming interface
 * @export
 */
export var PortfolioDataApiFp = function (configuration) {
    var localVarAxiosParamCreator = PortfolioDataApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} id
         * @param {string} [name]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPortfolioDataCopyIdPost: function (id, name, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiPortfolioDataCopyIdPost(id, name, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['PortfolioDataApi.apiPortfolioDataCopyIdPost']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPortfolioDataGet: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiPortfolioDataGet(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['PortfolioDataApi.apiPortfolioDataGet']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPortfolioDataGetIdGet: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiPortfolioDataGetIdGet(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['PortfolioDataApi.apiPortfolioDataGetIdGet']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {Portfolio} [portfolio]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPortfolioDataIdPut: function (id, portfolio, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiPortfolioDataIdPut(id, portfolio, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['PortfolioDataApi.apiPortfolioDataIdPut']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {Portfolio} [portfolio]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPortfolioDataPost: function (portfolio, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiPortfolioDataPost(portfolio, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['PortfolioDataApi.apiPortfolioDataPost']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
/**
 * PortfolioDataApi - factory interface
 * @export
 */
export var PortfolioDataApiFactory = function (configuration, basePath, axios) {
    var localVarFp = PortfolioDataApiFp(configuration);
    return {
        /**
         *
         * @param {number} id
         * @param {string} [name]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPortfolioDataCopyIdPost: function (id, name, options) {
            return localVarFp.apiPortfolioDataCopyIdPost(id, name, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPortfolioDataGet: function (options) {
            return localVarFp.apiPortfolioDataGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPortfolioDataGetIdGet: function (id, options) {
            return localVarFp.apiPortfolioDataGetIdGet(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} id
         * @param {Portfolio} [portfolio]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPortfolioDataIdPut: function (id, portfolio, options) {
            return localVarFp.apiPortfolioDataIdPut(id, portfolio, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {Portfolio} [portfolio]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPortfolioDataPost: function (portfolio, options) {
            return localVarFp.apiPortfolioDataPost(portfolio, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * PortfolioDataApi - object-oriented interface
 * @export
 * @class PortfolioDataApi
 * @extends {BaseAPI}
 */
var PortfolioDataApi = /** @class */ (function (_super) {
    __extends(PortfolioDataApi, _super);
    function PortfolioDataApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {number} id
     * @param {string} [name]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioDataApi
     */
    PortfolioDataApi.prototype.apiPortfolioDataCopyIdPost = function (id, name, options) {
        var _this = this;
        return PortfolioDataApiFp(this.configuration).apiPortfolioDataCopyIdPost(id, name, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioDataApi
     */
    PortfolioDataApi.prototype.apiPortfolioDataGet = function (options) {
        var _this = this;
        return PortfolioDataApiFp(this.configuration).apiPortfolioDataGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioDataApi
     */
    PortfolioDataApi.prototype.apiPortfolioDataGetIdGet = function (id, options) {
        var _this = this;
        return PortfolioDataApiFp(this.configuration).apiPortfolioDataGetIdGet(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} id
     * @param {Portfolio} [portfolio]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioDataApi
     */
    PortfolioDataApi.prototype.apiPortfolioDataIdPut = function (id, portfolio, options) {
        var _this = this;
        return PortfolioDataApiFp(this.configuration).apiPortfolioDataIdPut(id, portfolio, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {Portfolio} [portfolio]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioDataApi
     */
    PortfolioDataApi.prototype.apiPortfolioDataPost = function (portfolio, options) {
        var _this = this;
        return PortfolioDataApiFp(this.configuration).apiPortfolioDataPost(portfolio, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return PortfolioDataApi;
}(BaseAPI));
export { PortfolioDataApi };
/**
 * ReportApi - axios parameter creator
 * @export
 */
export var ReportApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {OfferSearch} [offerSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReportSMEReportPost: function (offerSearch, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/Report/SMEReport";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = serializeDataIfNeeded(offerSearch, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * ReportApi - functional programming interface
 * @export
 */
export var ReportApiFp = function (configuration) {
    var localVarAxiosParamCreator = ReportApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {OfferSearch} [offerSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReportSMEReportPost: function (offerSearch, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiReportSMEReportPost(offerSearch, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['ReportApi.apiReportSMEReportPost']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
/**
 * ReportApi - factory interface
 * @export
 */
export var ReportApiFactory = function (configuration, basePath, axios) {
    var localVarFp = ReportApiFp(configuration);
    return {
        /**
         *
         * @param {OfferSearch} [offerSearch]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReportSMEReportPost: function (offerSearch, options) {
            return localVarFp.apiReportSMEReportPost(offerSearch, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * ReportApi - object-oriented interface
 * @export
 * @class ReportApi
 * @extends {BaseAPI}
 */
var ReportApi = /** @class */ (function (_super) {
    __extends(ReportApi, _super);
    function ReportApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {OfferSearch} [offerSearch]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    ReportApi.prototype.apiReportSMEReportPost = function (offerSearch, options) {
        var _this = this;
        return ReportApiFp(this.configuration).apiReportSMEReportPost(offerSearch, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ReportApi;
}(BaseAPI));
export { ReportApi };
/**
 * SalesforceApi - axios parameter creator
 * @export
 */
export var SalesforceApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {string} [agentName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSalesforceGetOpportunitiesByAgentGet: function (agentName, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/Salesforce/getOpportunitiesByAgent";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (agentName !== undefined) {
                                localVarQueryParameter['agentName'] = agentName;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} [opportunityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSalesforceGetOpportunityDetailsGet: function (opportunityId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/Salesforce/getOpportunityDetails";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (opportunityId !== undefined) {
                                localVarQueryParameter['opportunityId'] = opportunityId;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * SalesforceApi - functional programming interface
 * @export
 */
export var SalesforceApiFp = function (configuration) {
    var localVarAxiosParamCreator = SalesforceApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} [agentName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSalesforceGetOpportunitiesByAgentGet: function (agentName, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiSalesforceGetOpportunitiesByAgentGet(agentName, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['SalesforceApi.apiSalesforceGetOpportunitiesByAgentGet']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} [opportunityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSalesforceGetOpportunityDetailsGet: function (opportunityId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiSalesforceGetOpportunityDetailsGet(opportunityId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['SalesforceApi.apiSalesforceGetOpportunityDetailsGet']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
/**
 * SalesforceApi - factory interface
 * @export
 */
export var SalesforceApiFactory = function (configuration, basePath, axios) {
    var localVarFp = SalesforceApiFp(configuration);
    return {
        /**
         *
         * @param {string} [agentName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSalesforceGetOpportunitiesByAgentGet: function (agentName, options) {
            return localVarFp.apiSalesforceGetOpportunitiesByAgentGet(agentName, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} [opportunityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSalesforceGetOpportunityDetailsGet: function (opportunityId, options) {
            return localVarFp.apiSalesforceGetOpportunityDetailsGet(opportunityId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * SalesforceApi - object-oriented interface
 * @export
 * @class SalesforceApi
 * @extends {BaseAPI}
 */
var SalesforceApi = /** @class */ (function (_super) {
    __extends(SalesforceApi, _super);
    function SalesforceApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {string} [agentName]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesforceApi
     */
    SalesforceApi.prototype.apiSalesforceGetOpportunitiesByAgentGet = function (agentName, options) {
        var _this = this;
        return SalesforceApiFp(this.configuration).apiSalesforceGetOpportunitiesByAgentGet(agentName, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} [opportunityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesforceApi
     */
    SalesforceApi.prototype.apiSalesforceGetOpportunityDetailsGet = function (opportunityId, options) {
        var _this = this;
        return SalesforceApiFp(this.configuration).apiSalesforceGetOpportunityDetailsGet(opportunityId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return SalesforceApi;
}(BaseAPI));
export { SalesforceApi };
/**
 * TariffDataApi - axios parameter creator
 * @export
 */
export var TariffDataApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffDataGetIdGet: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            assertParamExists('apiTariffDataGetIdGet', 'id', id);
                            localVarPath = "/api/TariffData/Get/{Id}"
                                .replace("{".concat("Id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffDataGetPortfolioTariffsIdGet: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            assertParamExists('apiTariffDataGetPortfolioTariffsIdGet', 'id', id);
                            localVarPath = "/api/TariffData/GetPortfolioTariffs/{Id}"
                                .replace("{".concat("Id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * TariffDataApi - functional programming interface
 * @export
 */
export var TariffDataApiFp = function (configuration) {
    var localVarAxiosParamCreator = TariffDataApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffDataGetIdGet: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiTariffDataGetIdGet(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['TariffDataApi.apiTariffDataGetIdGet']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffDataGetPortfolioTariffsIdGet: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiTariffDataGetPortfolioTariffsIdGet(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['TariffDataApi.apiTariffDataGetPortfolioTariffsIdGet']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
/**
 * TariffDataApi - factory interface
 * @export
 */
export var TariffDataApiFactory = function (configuration, basePath, axios) {
    var localVarFp = TariffDataApiFp(configuration);
    return {
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffDataGetIdGet: function (id, options) {
            return localVarFp.apiTariffDataGetIdGet(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTariffDataGetPortfolioTariffsIdGet: function (id, options) {
            return localVarFp.apiTariffDataGetPortfolioTariffsIdGet(id, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * TariffDataApi - object-oriented interface
 * @export
 * @class TariffDataApi
 * @extends {BaseAPI}
 */
var TariffDataApi = /** @class */ (function (_super) {
    __extends(TariffDataApi, _super);
    function TariffDataApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TariffDataApi
     */
    TariffDataApi.prototype.apiTariffDataGetIdGet = function (id, options) {
        var _this = this;
        return TariffDataApiFp(this.configuration).apiTariffDataGetIdGet(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TariffDataApi
     */
    TariffDataApi.prototype.apiTariffDataGetPortfolioTariffsIdGet = function (id, options) {
        var _this = this;
        return TariffDataApiFp(this.configuration).apiTariffDataGetPortfolioTariffsIdGet(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return TariffDataApi;
}(BaseAPI));
export { TariffDataApi };
/**
 * TenantApi - axios parameter creator
 * @export
 */
export var TenantApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTenantGetFeatureFlagsGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/Tenant/GetFeatureFlags";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * TenantApi - functional programming interface
 * @export
 */
export var TenantApiFp = function (configuration) {
    var localVarAxiosParamCreator = TenantApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTenantGetFeatureFlagsGet: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiTenantGetFeatureFlagsGet(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['TenantApi.apiTenantGetFeatureFlagsGet']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
/**
 * TenantApi - factory interface
 * @export
 */
export var TenantApiFactory = function (configuration, basePath, axios) {
    var localVarFp = TenantApiFp(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTenantGetFeatureFlagsGet: function (options) {
            return localVarFp.apiTenantGetFeatureFlagsGet(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * TenantApi - object-oriented interface
 * @export
 * @class TenantApi
 * @extends {BaseAPI}
 */
var TenantApi = /** @class */ (function (_super) {
    __extends(TenantApi, _super);
    function TenantApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    TenantApi.prototype.apiTenantGetFeatureFlagsGet = function (options) {
        var _this = this;
        return TenantApiFp(this.configuration).apiTenantGetFeatureFlagsGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return TenantApi;
}(BaseAPI));
export { TenantApi };
/**
 * UtilsApi - axios parameter creator
 * @export
 */
export var UtilsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {number} id
         * @param {number} [offerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilsDeleteAttachmentIdDelete: function (id, offerId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            assertParamExists('apiUtilsDeleteAttachmentIdDelete', 'id', id);
                            localVarPath = "/api/Utils/DeleteAttachment/{Id}"
                                .replace("{".concat("Id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (offerId !== undefined) {
                                localVarQueryParameter['OfferId'] = offerId;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {number} [offerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilsDownloadAttachmentIdGet: function (id, offerId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            assertParamExists('apiUtilsDownloadAttachmentIdGet', 'id', id);
                            localVarPath = "/api/Utils/DownloadAttachment/{Id}"
                                .replace("{".concat("Id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (offerId !== undefined) {
                                localVarQueryParameter['OfferId'] = offerId;
                            }
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilsGetMaintenanceStatusGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/Utils/GetMaintenanceStatus";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilsGetNotificationMessagesGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/api/Utils/GetNotificationMessages";
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilsPrintIdGet: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            assertParamExists('apiUtilsPrintIdGet', 'id', id);
                            localVarPath = "/api/Utils/Print/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {string} fileName
         * @param {File} formFile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilsUploadAttachmentIdPost: function (id, fileName, formFile, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            assertParamExists('apiUtilsUploadAttachmentIdPost', 'id', id);
                            // verify required parameter 'fileName' is not null or undefined
                            assertParamExists('apiUtilsUploadAttachmentIdPost', 'fileName', fileName);
                            // verify required parameter 'formFile' is not null or undefined
                            assertParamExists('apiUtilsUploadAttachmentIdPost', 'formFile', formFile);
                            localVarPath = "/api/Utils/UploadAttachment/{Id}"
                                .replace("{".concat("Id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
                            // authentication Bearer required
                            return [4 /*yield*/, setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication Bearer required
                            _a.sent();
                            if (fileName !== undefined) {
                                localVarFormParams.append('FileName', fileName);
                            }
                            if (formFile !== undefined) {
                                localVarFormParams.append('FormFile', formFile);
                            }
                            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                            setSearchParams(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = localVarFormParams;
                            return [2 /*return*/, {
                                    url: toPathString(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
/**
 * UtilsApi - functional programming interface
 * @export
 */
export var UtilsApiFp = function (configuration) {
    var localVarAxiosParamCreator = UtilsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} id
         * @param {number} [offerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilsDeleteAttachmentIdDelete: function (id, offerId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiUtilsDeleteAttachmentIdDelete(id, offerId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['UtilsApi.apiUtilsDeleteAttachmentIdDelete']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {number} [offerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilsDownloadAttachmentIdGet: function (id, offerId, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiUtilsDownloadAttachmentIdGet(id, offerId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['UtilsApi.apiUtilsDownloadAttachmentIdGet']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilsGetMaintenanceStatusGet: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiUtilsGetMaintenanceStatusGet(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['UtilsApi.apiUtilsGetMaintenanceStatusGet']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilsGetNotificationMessagesGet: function (options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiUtilsGetNotificationMessagesGet(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['UtilsApi.apiUtilsGetNotificationMessagesGet']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilsPrintIdGet: function (id, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiUtilsPrintIdGet(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['UtilsApi.apiUtilsPrintIdGet']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} id
         * @param {string} fileName
         * @param {File} formFile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilsUploadAttachmentIdPost: function (id, fileName, formFile, options) {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, index, operationBasePath;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.apiUtilsUploadAttachmentIdPost(id, fileName, formFile, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            index = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            operationBasePath = (_c = (_b = operationServerMap['UtilsApi.apiUtilsUploadAttachmentIdPost']) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
/**
 * UtilsApi - factory interface
 * @export
 */
export var UtilsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = UtilsApiFp(configuration);
    return {
        /**
         *
         * @param {number} id
         * @param {number} [offerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilsDeleteAttachmentIdDelete: function (id, offerId, options) {
            return localVarFp.apiUtilsDeleteAttachmentIdDelete(id, offerId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} id
         * @param {number} [offerId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilsDownloadAttachmentIdGet: function (id, offerId, options) {
            return localVarFp.apiUtilsDownloadAttachmentIdGet(id, offerId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilsGetMaintenanceStatusGet: function (options) {
            return localVarFp.apiUtilsGetMaintenanceStatusGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilsGetNotificationMessagesGet: function (options) {
            return localVarFp.apiUtilsGetNotificationMessagesGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilsPrintIdGet: function (id, options) {
            return localVarFp.apiUtilsPrintIdGet(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} id
         * @param {string} fileName
         * @param {File} formFile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUtilsUploadAttachmentIdPost: function (id, fileName, formFile, options) {
            return localVarFp.apiUtilsUploadAttachmentIdPost(id, fileName, formFile, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * UtilsApi - object-oriented interface
 * @export
 * @class UtilsApi
 * @extends {BaseAPI}
 */
var UtilsApi = /** @class */ (function (_super) {
    __extends(UtilsApi, _super);
    function UtilsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {number} id
     * @param {number} [offerId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilsApi
     */
    UtilsApi.prototype.apiUtilsDeleteAttachmentIdDelete = function (id, offerId, options) {
        var _this = this;
        return UtilsApiFp(this.configuration).apiUtilsDeleteAttachmentIdDelete(id, offerId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} id
     * @param {number} [offerId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilsApi
     */
    UtilsApi.prototype.apiUtilsDownloadAttachmentIdGet = function (id, offerId, options) {
        var _this = this;
        return UtilsApiFp(this.configuration).apiUtilsDownloadAttachmentIdGet(id, offerId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilsApi
     */
    UtilsApi.prototype.apiUtilsGetMaintenanceStatusGet = function (options) {
        var _this = this;
        return UtilsApiFp(this.configuration).apiUtilsGetMaintenanceStatusGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilsApi
     */
    UtilsApi.prototype.apiUtilsGetNotificationMessagesGet = function (options) {
        var _this = this;
        return UtilsApiFp(this.configuration).apiUtilsGetNotificationMessagesGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilsApi
     */
    UtilsApi.prototype.apiUtilsPrintIdGet = function (id, options) {
        var _this = this;
        return UtilsApiFp(this.configuration).apiUtilsPrintIdGet(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} id
     * @param {string} fileName
     * @param {File} formFile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilsApi
     */
    UtilsApi.prototype.apiUtilsUploadAttachmentIdPost = function (id, fileName, formFile, options) {
        var _this = this;
        return UtilsApiFp(this.configuration).apiUtilsUploadAttachmentIdPost(id, fileName, formFile, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return UtilsApi;
}(BaseAPI));
export { UtilsApi };
